
//IMPORTS
import React, { useEffect, useRef } from 'react'
import { Tooltip } from '@mui/material'
//COMPONENTS
import AgGridTable from 'src/components/AgGridTable'
//REDUX
import { useDispatch } from 'react-redux'
//SERVICES
import { alertQuestionService } from 'src/services/alertQuestionService'
import { mercadoServices } from 'src/services/apiMercados'
import { modalCRUDService } from 'src/services/modalCRUDService'
//UTILS
import { getColorCellValid } from 'src/util/functions'
//CONSTANTS
import { GlobalConstants } from 'src/data/GlobalConstants'
//STYLES
import { Colors } from 'src/assets/colors/Colors'


const columnDef = [
    { headerName: 'ID Agente Comercial', field: "COMERCIAL", resizable: true, sortable: true, filter: true, width: 40 },
    { headerName: 'Código ERP', field: "COD_CRM", resizable: true, sortable: true, filter: true, width: 40 },
    { headerName: 'ID Mercado', field: "MERCADO", resizable: true, sortable: true, filter: true, width: 40 },
    { headerName: 'Estado', field: "msg", resizable: true, sortable: true, filter: true, width: 40 },
    { headerName: 'Fila', field: "fila", resizable: true, sortable: true, filter: true, width: 40 },
    { headerName: 'Error', field: "error", hide: true },
]

const TableExcelClienteMercado = ({properties}) => {
  const { data, file } = properties;

  //* Dispatch
  const dispatch = useDispatch();

  //* Referencias
  const tableRef = useRef(null);
  const newRef = useRef(null);
  const updateRef = useRef(null);
  const deleteRef = useRef(null);
  const errorRef = useRef(null);


  //* Effects
  useEffect(() => {
    newRef.current.innerText = data.countNew;
    updateRef.current.innerText = data.countUpdate;
    deleteRef.current.innerText = data.countDelete;
    errorRef.current.innerText = data.countError;
  }, [])

  /** Functions **/

  //* Guardamos los registros validos de la tabla
  const save = () => {
    alertQuestionService.showAlert({
      title: 'Guardar Clientes Mercados',
      question: '¿Está seguro de guardar los clientes mercados?',
      message: 'Ten en cuenta que no se guardaran los clientes mercados con errores.',
      actionBtnAceptar: async () => {
        try {
          alertQuestionService.clear()
          let arrSave = [];

          tableRef.current.api.forEachNode((nodo) => {
            if(!nodo.data.error){
              arrSave.push(nodo.data);
            }
          });

          if(arrSave.length == 0){
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning, message: 'Ninguna regla fue guardada.'}});
            modalCRUDService.clear()
            return;
          }
          const { status, msg } = await mercadoServices.saveExcelClienteMercado(arrSave, file);

          if(status){
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess, message: msg } });
            modalCRUDService.clear()
          }

        } catch (error){
          dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: error.toString() } })
        }
       },
      actionBtnCancelar: () => {
        alertQuestionService.clear()
      },
      type: GlobalConstants.alertInfo
    })
  }

  return (
    <>
      <div className='d-flex justify-content-center boxShadow borderRadius4 mx-5 py-3 w-auto' style={{backgroundColor: Colors.COLOR_CELL_ERROR}}>
            <p style={{margin: 0, fontWeight: 'bold', textAlign: 'center', fontSize: '16px'}}>Cada edición realizada en las relaciones cliente - mercado generan una solicitud de actualización hacia el sistema CRM.</p>
      </div>
      <div className='d-flex align-items-center justify-content-between mt-4'>
        <div className='d-flex justify-content-between w-75 pl-3'>
          <div>
            <strong>Nuevos: </strong>
            <span ref={newRef} style={{fontSize: 20, color: '#64DF38', fontWeight: 'bold'}}> 0</span>
          </div>
          <div>
            <strong>Actualización: </strong>
            <span ref={updateRef} style={{fontSize: 20, color: '#FFC40C', fontWeight: 'bold'}}> 0</span>
          </div>
          <div>
            <strong>Eliminados: </strong>
            <span ref={deleteRef} style={{fontSize: 20, color: '#4040FF', fontWeight: 'bold'}}> 0</span>
          </div>
          <div>
            <strong>Errores: </strong>
            <span ref={errorRef} style={{fontSize: 20, color: 'red', fontWeight: 'bold'}}> 0</span>
          </div>
        </div>
        <div>
          <Tooltip title="Guardar" aria-label="guardar" >
            <a className="icon-container-actions d-flex "
            onClick={save}>
                <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                <i style={{color: Colors.COLOR_GREEN_DARK}} className="far fa-save fa-2x"/>
            </a>
          </Tooltip>
        </div>

      </div>
      <AgGridTable
        columnDef={columnDef}
        referencia={tableRef}
        dataList={data.data || []}
        getRowStyle={getColorCellValid}
      />
    </>
  )
}

export default TableExcelClienteMercado
